(function () {
    'use strict';
    angular.module('app').controller('DriversController', DriversController);

    DriversController.$inject = ['$scope', 'FleetDriversTableService', '$routeParams'];

    function DriversController($scope, FleetDriversTableService, $routeParams) {

        const vm = this;
        
        init();
        function init() {
            const paginationData = {
                'routes.area.id': $routeParams.areaId,
                'routes.id' : $routeParams.routeId
            };
            getDrivers(paginationData);
        }

        function getDrivers(filter) {
            vm.driversTableData = new FleetDriversTableService({
                filter
            }).tableData;
        }

    }
})();


// WEBPACK FOOTER //
// ./js/controllers/fleets/DriversController.js